module.exports = __webpack_public_path__ + "img/cut1.32478fd7.svg";